const inits = {
  studyID: null,
  studyTitle: null,
  studyDetailData: null,
  studySite: null,
  studyTotal: null,
  prevStudyID: null
}

const StudyDetailReducer = (s = inits, action) => {
  const {payload} = action
  switch (action.type) {
    case '_STUDY_DETAIL':
      return { ...s, [payload[0]]: payload[1] }

    default:
      return s;
  }
};
export default StudyDetailReducer
